// API functions for call routing
import { getGenericDeviceConfiguration, updateCallRoutingConfiguration } from '@/lib/api'
import type { CallRoutingConfiguration } from './types'

/**
 * Fetches the current call routing configuration from the API
 */
export const fetchCallRoutingConfiguration = async (): Promise<CallRoutingConfiguration> => {
    try {
        const response = await getGenericDeviceConfiguration()

        // Parse the response and return proper configuration
        if (response && response.value) {
            try {
                const parsedConfig = JSON.parse(response.value)
                return {
                    selectionElements: parsedConfig.selectionElements || []
                }
            } catch (parseError) {
                console.error('Error parsing call routing configuration:', parseError)
                return { selectionElements: [] }
            }
        }

        return { selectionElements: [] }
    } catch (error) {
        console.error('Error fetching call routing configuration:', error)
        return { selectionElements: [] }
    }
}

/**
 * Saves the call routing configuration to the API
 */
export const saveCallRoutingConfiguration = async (configuration: CallRoutingConfiguration): Promise<boolean> => {
    try {
        const configString = JSON.stringify(configuration)
        const response = await updateCallRoutingConfiguration(configString)

        // Check if response has errorCode property (error case) or is successful
        return !(response as any).errorCode
    } catch (error) {
        console.error('Error saving call routing configuration:', error)
        return false
    }
}